// extracted by mini-css-extract-plugin
module.exports = {"calendar-table-cell":"_1dP6WIR_0wPAGBubVhEcrS","calendar-table-cell--starts-week":"_12oObwDpCoHFJda9EwZhjL"};